import firebase from '@/firebase.js'
const { messaging } = firebase
export default {
    data() {
      return {    
      }
    },
    methods: {
        //get messaging token
		getMessagingToken () {
			messaging.getToken().then(async (token) => {
				if (token) {
						const currentMessageToken = localStorage.getItem('messagingToken')
						console.log('token will be updated', currentMessageToken != token)
						if(currentMessageToken != token){
							await this.saveToken(token)
						}
					} else {
						console.log('No Instance ID token available. Request permission to generate one.');
						this.notificationsPermisionRequest();
					}
			}).catch(function(err) {
				console.log('An error occurred while retrieving token. ', err);
			});
        },
        // request permision for notifications
		notificationsPermisionRequest () {
			messaging.requestPermission()
			.then(() => {
				this.getMessagingToken();
			})
			.catch((err) => {
				console.log('Unable to get permission to notify.', err);
			});
        },
        // listen for when the notification token has been renewed
		listenTokenRefresh() {
			const currentMessageToken = localStorage.getItem('messagingToken')
			console.log('currentMessageToken',currentMessageToken)			
			if(currentMessageToken === null){
				this.getMessagingToken()
				messaging.onTokenRefresh(function() {
					messaging.getToken().then(function(token) {
						this.saveToken(token);
					}).catch(function(err) {
						console.log('Unable to retrieve refreshed token ', err);
					});
				});
			}
        },
        //save notifications token
		saveToken(token) {
			localStorage.setItem('messagingToken',token)        
            var details = localStorage.getItem(JSON.parse(this.details))
			var topic_name = details.name.replace(/ /g, "")
			this.$http({
				method: 'post',
				url: ` https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic_name}`,
				headers:{
					Authorization: `Bearer ${this.$serverKey}`
				}, 
			}).then(()=>{
				this.showSuccess("Successfully subscribed to notifications")
			}).catch(()=>{
				this.showAlert("an error occured while subscribing to notifications")
			})

		},
    },
  }